import { logger } from 'lib/analytics/logger'
import { apiV2 } from 'lib/api/v2'
import { dispatchToaster } from 'lib/utils/notifications'

export function openChat() {
  if (window.zE) {
    window.zE('messenger', 'loginUser', async function (callback) {
      try {
        const token = await getZendeskJWT()

        callback(token)
        window.zE('messenger', 'show')
        window.zE('messenger', 'open')
      } catch (error) {
        logger.error('Failed to fetch new JWT:', error)

        dispatchToaster({
          title: 'Oops!',
          variant: 'error',
          message:
            'Não foi possível autenticar ao Zendesk. Por favor, entre em contato com o suporte por outro canal.'
        })
      }
    })
  }
}

export async function getZendeskJWT() {
  const { data } = await apiV2.get<string>('/zendesk/jwt')
  return data
}
